module.exports = __webpack_public_path__ + "img/thank-you.e05a1dd8.svg";